import { RMAXLogger } from "@RMAXLogger";

export const PRINT_PHYSICAL_DR_FAILED_MESSAGE = "PrintPhysicalDR failed";

export function logPhysicalDrFailure(context: string, payload: unknown): void {
  let detail: string;
  try {
    detail = JSON.stringify(payload);
  } catch {
    detail = String(payload);
  }
  RMAXLogger.error(`PrintPhysicalDR: ${context}`, { detail });
}
